import { render, staticRenderFns } from "./cadtitulosreceber.vue?vue&type=template&id=5154d169&"
import script from "./cadtitulosreceber.vue?vue&type=script&lang=js&"
export * from "./cadtitulosreceber.vue?vue&type=script&lang=js&"
import style0 from "./cadtitulosreceber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports